import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import {
    RpcSmeExtensionRequest,
    RpcSmeExtensionRequestKey } from './rpc-sme-extension-model';

export class RpcSmeExtensionRequestClient {
    /**
     * Get sme extensions request client call.
     *
     * @param data the extension object.
     * @return Promise<Extension> the promise object.
     */
    public static getExtensionsRequest(rpc: Rpc, data: RpcSmeExtensionRequest): Promise<void> {
        return RpcInboundClient.call(rpc, RpcSmeExtensionRequestKey.command, RpcSmeExtensionRequestKey.version, data);
    }

    public static installExtension(rpc: Rpc, data: RpcSmeExtensionRequest): Promise<void> {
        return RpcInboundClient.call(rpc, RpcSmeExtensionRequestKey.command, RpcSmeExtensionRequestKey.version, data);
    }
}
